const styles = {
  draft: "bg-slate-100 text-slate-700 border-slate-200",
  invited: "bg-blue-50 text-blue-700 border-blue-200",
  awaiting_payment: "bg-amber-50 text-amber-800 border-amber-200",
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  change_pending: "bg-violet-50 text-violet-700 border-violet-200",
  cancel_at_period_end: "bg-orange-50 text-orange-800 border-orange-200",
  withdrawn: "bg-red-50 text-red-700 border-red-200",
  terminated: "bg-slate-100 text-slate-500 border-slate-200",
  legacy: "bg-stone-100 text-stone-700 border-stone-300",
  pending: "bg-amber-50 text-amber-800 border-amber-200",
  grace: "bg-orange-50 text-orange-800 border-orange-200",
  blocked: "bg-red-50 text-red-700 border-red-200",
};

const labels = {
  draft: "Entwurf",
  invited: "Eingeladen",
  awaiting_payment: "Zahlung ausstehend",
  active: "Aktiv",
  change_pending: "Änderung ausstehend",
  cancel_at_period_end: "Endet zum Zeitraum",
  withdrawn: "Widerrufen",
  terminated: "Beendet",
  legacy: "Legacy",
  pending: "Ausstehend",
  grace: "Kulanz",
  blocked: "Gesperrt",
};

export default function ContractStatus({ status = "legacy" }) {
  return <span className={`inline-flex rounded-full border px-2.5 py-1 text-xs font-semibold ${styles[status] || styles.legacy}`}>{labels[status] || status}</span>;
}
